export default "__VITE_ASSET__6228533c__"